module.exports = __webpack_public_path__ + "img/sa.ec6db323.png";